import { createContext } from 'react';
const ErrorReporterContext = createContext(undefined);
export default ErrorReporterContext;
